// MUST KEEP IT for mobile view to work
// eslint-disable-next-line
import React from 'react';
import { isMobile, isDesktop } from 'react-device-detect';

export const orientationLandscape = '@media (orientation: landscape)';

export const orientationPortrait = '@media (orientation: portrait)';

export const mobileMediaQuery = isMobile ? `@media screen` : `@media not screen`;

export const desktopMediaQuery = isDesktop ? `@media screen` : `@media not screen`;

export const useMobileMediaQuery = () => isMobile;

export const useDesktopMediaQuery = () => isDesktop;

export const MobileView = ({ children }) => {
  if (children && typeof children === 'function') {
    return children(isMobile)
  }
  return children && isMobile ? (children) : null
};

export const DesktopView = ({ children }) => {
  if (children && typeof children === 'function') {
    return children(isDesktop)
  }
  return children && isDesktop ? (children) : null
};
